import React from 'react'
import { Create } from 'react-admin'
import { STANDARD_PRICING_STARTUP } from 'services/cfg/form'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'
import FoodForm from './FoodForm'

const FoodCreate: React.FC = () => {
  return (
    <SectionWrapper>
      <Create record={{ pricing: STANDARD_PRICING_STARTUP }}>
        <FoodForm />
      </Create>
    </SectionWrapper>
  )
}

export default FoodCreate
